import produce from 'immer'
import { assign } from 'lodash'

import { createSelectOptions } from '../../helpers'
import { COMMON_FETCH_LANGUAGES } from '../action-types'
import { LANGUAGES_INITIAL_STATE } from '../initial-states'

const languagesReducer = (state = LANGUAGES_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_LANGUAGES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_LANGUAGES.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          data: action.payload.data.languages,
          options: createSelectOptions(
            action.payload.data.languages,
            'name',
            'id',
          ),
        }),
      )

    case COMMON_FETCH_LANGUAGES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_LANGUAGES.CLEANUP:
      return { ...LANGUAGES_INITIAL_STATE }

    default:
      return state
  }
}

export default languagesReducer
